import React from 'react'

import { useRef } from 'react'

import * as S from './styles'
import HamburguerIcon from '../Icons/HamburguerIcon'
import { ReactComponent as LogoutIcon } from 'presentation/assets/icons/exit.svg'
import { useStores } from 'presentation/hooks/use-stores'
import { observer } from 'mobx-react'
import { profiles } from './profiles'
import { useHistory } from 'react-router'

const SideMenu = observer(() => {
  const ref = useRef(null)

  const menuStore = useStores().menu
  const accountStore = useStores().currentAccount
  const permissions = useStores().permissions
  const history = useHistory()

  const logout = async () => {
    await accountStore.removeCurrentAccount()
    permissions.clean()
    history.push('/login')
    menuStore.close()
  }

  const redirect = (url: string) => {
    history.push(url)
    menuStore.close()
  }

  return (
    <>
      <S.Wrapper isOpen={menuStore.isOpen}>
        <S.MenuFull
          ref={ref}
          aria-hidden={!menuStore.isOpen}
          isOpen={menuStore.isOpen}
          aria-label="Side menu"
        >
          <S.HamburguerIconWrapper
            aria-label="Close menu icon"
            onClick={() => menuStore.close()}
          >
            <HamburguerIcon />
          </S.HamburguerIconWrapper>
          <S.MenuNav>
            {profiles[accountStore.getCurrentAccount()?.user?.role]?.map(
              (link) => (
                <S.MenuItem
                  onClick={() => redirect(link.link)}
                  key={link.label}
                >
                  {link.icon}
                  <S.MenuLink>{link.label}</S.MenuLink>
                </S.MenuItem>
              )
            )}
            <S.MenuItem onClick={logout}>
              <div>
                <LogoutIcon />
              </div>
              <S.MenuLink>Sair</S.MenuLink>
            </S.MenuItem>
          </S.MenuNav>
        </S.MenuFull>
      </S.Wrapper>
      {menuStore.isOpen && (
        <S.ClickInterceptor
          data-testid="Side menu interceptor"
          onClick={() => menuStore.isOpen && menuStore.close()}
        ></S.ClickInterceptor>
      )}
    </>
  )
})

export default SideMenu
